
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import HeaderTitle from './HeaderTitle.vue';
import ActionButton from './ActionButton.vue';
import StoresSwitcher from './StoresSwitcher.vue';
import { StoreModel } from '@/models/store';
import { EventBus } from '@/main';
import ForecastSetting from '@/models/forecast_setting';

@Component({
  components: {
    HeaderTitle,
    ActionButton,
    StoresSwitcher,
  },
})
export default class VerticalMenuBar extends Vue {
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  @Prop({ default: false })
  public mini!: boolean;
  @Prop({default: null})
  public app!: any;  
  public search: string = '';
  public menuPurpose: string = '';
  public canExpandOnHover: boolean = true;
  private forecastSetting = new ForecastSetting();
  private currentMethodology: string = '';

  private menuMode: string = 'ANALYTICS';
  public get getMenuItems() {
    return this.menuMode === 'ANALYTICS' ? this.analyticsMenu : this.operationalMenu;
  }

  get canAccessOperationalMode(): boolean {
    const validateValues = [
      {
        code: 'operational_mode',
        value: 'unlocked'
      }
    ];
    const validateResult = this.store.validateRule(validateValues);
    return validateResult.isValidate;
  }

  @Watch('menuMode')
  private onMenuModeChange() {
    // Reset all expanded sections
    this.expandedSections = {};
    
    // Expand first section of new menu mode
    const firstSection = this.getMenuItems[0];
    if (firstSection) {
      this.$set(this.expandedSections, firstSection.section, true);
    }
  }

  public switchMenuMode(mode: string) {
    if (mode === 'OPERATIONAL' && !this.canAccessOperationalMode) {
      this.$emit('error', 'Please upgrade your plan to access Operational Mode');
      return;
    }
    this.menuMode = mode;
    localStorage.setItem('menuMode', mode);
  }

  public pinMenu() {
    EventBus.$emit('pin-menu', this.canExpandOnHover);
    this.canExpandOnHover = !this.canExpandOnHover;
  }

  public get operationalMenu(): any[] {
    return [
      {
        section: 'buying-list',
        title: 'Buying list', 
        icon: 'mdi-format-list-bulleted',
        type: 'group',
        items: [
          {
            title: 'Buying calendar',
            icon: 'mdi-calendar-month',
            type: 'single',
            link: '/buying-calendar',
          },
          {
            title: 'Buying table',
            icon: 'mdi-table',
            type: 'single',
            link: '/buying-table',
          },    
          {
            title: 'Buying list',
            icon: 'mdi-format-list-bulleted',
            type: 'single',
            link: '/buying-lists',
          },
          {
            title: 'Suppliers',
            icon: 'mdi-truck',
            type: 'single',
            link: '/suppliers',
          },
          
        ]
      },
      {
        section: 'inventory-tracking',
        title: 'Inventory status',
        icon: 'mdi-cube-outline',
        type: 'group',
        items: [
          {
            title: 'Inventory tracking overview',
            icon: 'mdi-view-grid-plus',
            type: 'single',
            link: '/board/1460',
          },
          {
            title: 'Inventory on-hand',
            icon: 'mdi-package-variant-closed',
            type: 'single',
            link: '/reports/31?report_query=eJztmU1v2zgQhv-KoNMWcADHXbdb31K32AbbItk67R6CQqAp2iZCkQpJOTWC_Ped0YclWbIjRUrdQ3IIouEM-WhIii8n967lVjB34s6sojeOks6KSN-Zb5xLrfyIWuc70ZxI6w5cuiLaXm1CdIfHFTFTtLgTqyM2cM1K3aWGBREGLUwwapk_JdqfKhEF0riT63tXkgD7SHt2zgOyZNi_8tG8TsweT80-sSQdNTOJiJsvJAy5XNYEkMiqWTz0loQqofS59NnPHE5pS-b47oj_MNhipS-eA51bFlzjL-cDM1Tz0HIlf5TJLPtpK2DzjRduO-tIVZiGUpoaYOSeHRlm_3zLx0_fzDM3UQOGsndXDqs0cz4rSnAmcqTMcp390XCSRN5TR7JzuWYS6DbOvxGknNtNTnd9Rm1EhFP12cH0GYWlLCqke-P74KYqgFHqsHna5t22w63EdcecqiDgFr4odZw0a2wLWg3scyF8JyJih1bBVBm7Q0ojrZmkm8eXAAZ3p_3KLOGiglo0NyXc6ar3_eRcMk1Z8UMICzR12s6fFyZOO9DhNnR3pe7roPeFcBB_jR5PZi9Fdwf_aCzsFtxrf2tlDOqBBS9ys8zBW6IDHnXg0HSd1Ef3iZ0AO1-IXnL5KLcXxH4Ns36wj-4v8U0CeLq1M-wIbB5t8a3YBvRw4DIh8HS41JwWPxAle1Ou3c46sl1oDjmHj-IunEobYHJa0JWjelOTBqYzKm37TBFRtO_QySiYM71XRNG0q34kZRUtE9Qt0EohvSjNKhZoxzZIW_fuOGdrONOwpU53kKyxre6oBnYn_UDwElSrj_ykqS3lblgPO1Y6n_CSWcOopIf3z7aMu2HdGYFNoNqYKmm1EnWst4kLrLHYpS3zvvA-1Jxhel2_CHTa1pa2EtfDHicLBhlOCg81qCZu9wy2t8Wtje3j_iHWRM4195fM-aMqG18duot6IV8r6x24BqYeIDq88kjlC--rZjl4ZoKaVOZ5iw2FxF2tmDMjQQhf0K9KBc-bu8pgx0hfA4hWGfyPiBuIlr6CrycjvnOxWIBAed5M7h30GBltAdMgsz8GbsCIiTR7pLLi84BJg9WhuFZUKKaBStxYTk362lcqdD7x5QqajCXaenBFQPtoOPrz5HR0MnoLLQxOqdw-PhmenozGOApbkEhYTxO5xMbXQx-sCy4sKJtCzTSrys4ssZGpqcZl9vg2CJEuoZavmQvvqyCLBF4P7y-3NZUxzEmSbhWXOMHuaXVnvJqJg6-mOTRv0H1INAlKBd_ZSt05kKYc26pQFmHPhEDS-DlFM7B4BKvBheXFjY1v1cko3Hcn4zcD9zOZMwFemNekDoF_416KPd7mHqfDggs8bH3-yn1GRZ9RweddYaSizzj3eTPMffDVcid8wnzjsrzQPk6y-w5_8LUU8eMds12pWSHd0yyEAMz-k4rpT6hyNylBV7t1ZnGdt6ZUfPxi6S8vex6jgHmsUuQvKCr-TuXB36DQ9yJPm0mAFzXaUo2-iM-exGesq-D4TWUVHNv38bM7OR24HE5cA9-Ky9gwHiaS4P0GzvZUHuBxDE9xV2BaahWFWXv8kDqgoo2MnanCf-AD0JS8YHmAySGCRiKuXQfMatCvSSwcIqDYuFHSg3QCy_0DykGZ_OM-qcVNXj_8D1eUaFY',
          },
          {
            title: 'Inventory remaining days',
            icon: 'mdi-calendar-clock',
            type: 'single',
            link: '/reports/212',
          },
        ]
      },
      {
        title: 'Settings',
        icon: 'mdi-cog',
        type: 'group',
        items: [
          {
            title: 'Replenishment Parameters',
            icon: 'mdi-cog',
            type: 'single',
            link: '/settings/replenishment-parameters',
          },
          {
            title: 'Incoming Inventory',
            icon: 'mdi-package-variant',
            type: 'single',
            link: '/settings/incoming-inventory',
          },
          {
            title: 'Store settings',
            icon: 'mdi-cog',
            type: 'single',
            link: '/settings/store',
          },
        ],
      }
    ];

  } 

  public get analyticsMenu(): any[] {
    return [
      {
        section: 'demand-forecasting',
        title: 'Demand forecasting',
        items: this.forecastingItems,
        icon: 'mdi-chart-timeline-variant',
      },
      {
      section: 'reorder-suggestion',
      title: 'Reorder suggestion',
      icon: 'mdi-truck',
      type: 'group',
      items: [
        {
          title: 'Replenishment metrics',
          link: '/board/1606',
          icon: 'mdi-chart-line',
        },
        {
          title: 'Reorder suggestion',
          icon: 'mdi-clipboard-check-outline',
          link: '/reports/36/inventory-replenishment/672?report_query=eJztWW1v2zYQ%2FiuCgAEbZhW2EtuJv2XJBhRr2ixJAwxBIDAS7XClRJWkvBhB%2FvuOlG2eaNmzHaDoBn9JoONzL7wj74V%2BCTXTnIaj8H0xpYUWchZc05LTgqmnHAhhJ0yfiNS3s9Kg4POJqHNDCUdaVrQTqifx95wwJlwZCuU01TQ7JzI7F7zKCxWO7l%2FCguRGxpUUWZVaySKzqjXN782f4IKqVLJSM1E8wHpGNJkr1vTZcPCKqUtSlqyYAPFxlpRzYa%2Bdpfw7IhkpkPzpkvBvAhdIJO3m989O0lxbor5UO5lnGZDQaypkRmXwRwXamJ45DfdsEYdE4jh47shoynLCV1Su4W7TfUE0RXplTU5ACfWV1cimJozH4j8XTKvgRvAMCVfwmXydbzYpiST5lhtq4VzVZkBBCXvKCHYlmVJJJhRMZHyWVAaaWHm7GLBZCLblLPurUnDsg2ovoxThVCVa0iJ7q2lIFDbwAyVZcMtyGvwINqmfkFVwajIhEw6IRANiSwt8tsbFIWOqZ8GNFukXfBQsOVGGDIxTyrc9CSuMbaf6SjB89ZfHujT0LTU1eLASlyNbLu5ZqivCg1XMllrX8jctSEUO%2BPbMUa8lLgl83c2EDRKwERdweAIxDnDJyAkrjBAUaBsoc9CQuJKTwuC2jfkmGdikS9CeV3mb95xFsLX9fdPO3LCBPG9hA3l%2Bgw2tzG1%2BsLcuOBdTm%2BhnyvNC7dfULFvv7uADn7XNA5u0wxb21d7C2rb3T%2BtKqzG%2Fvtl7xL7J2Lbr9XrB8P30rjBivb%2BxZyg2a7WOzfJ%2BettY25Lt%2BSzlbT1Eaug7JlvL45d2OEMKZ%2FNFxTO1Dk6B8jN6WkkoeulsbalcMoavD50wp0RVkm7om0A6lLVCQUNaN3Sul1Qaet666o3CuBsfR91h1DuBFSiKDXqvG%2FWGRhQdk4rrRJJiYhaPciCOGddUQn8M9pRsKnQibP9bN9u2yWh0z8su49aW96VvcM3vQCPLK6Deh73wYf41dxFnyuuEiyp%2FBAs6dunOQGuFLAtHJ53wA3mEUjsKf%2B51uz8A6q4WHcbvujZcBnaKYKcNVO%2Fd6RLV6yLYiQc7cbAegg092NDBYgQbeLCBgx0hWN%2BD9R3sGMGOPdixg%2FUR7MiDHTnYAMFiDxY72LDh3ias52A4Ck2Uw6AQRE1RXRSCGIUgij2YC0GMQhAdeTAXghiFIDr2YC4EMQpB1PdgLgQxCkE08GAuBDEKQTT0YC4EMQpBdOLBXAhiFILo1IP1bJbggmQ2i9jxFmWoX59TXpmlQFQ6EuPIVqcga1Q8WErEOEGdDF2w4XtaCP%2BiKkDY7NoyZq5e1AGK2EeBdgGCF3sdoHD9SRUCzeBr41ZvYMgPbkXp9qVFWeANnHH%2Bth30UcD6yDZ3QPooVr0uvgYuE%2FXRXYkxJkYYdFf6GNN3mAG6KGZrDmS%2BWnz14N49TA0R0tSZdW8fwfscqpFzJrOfyN%2BHN5LvYNhaTjWr8%2FI3HW4Or0WH16LDa9F%2F8LXoO3irOTyMHB5GDg8j%2F6uHkTubRp30%2Bjv4aFa3arjqPPwt31qcpk94UvKuwMqotKWnVvhaOukA%2Fo9hk5dETliBlC66z9KuJ7ld9xRDXU7r16Cm4lbe5nlAbRXKf56rG90XSmS7eH2TjPUmXUNlLCq6hS2SamgcEjvfvdUmLGu9bXXEtjBtIoVS8yC81TQsy455pTnK9ZMcTHIv9jscwbTNYBhTV1ReWUIf5kUFQ98vMzMMr%2B%2FLH2qYGeIAaH5BBwoorUrLufiYr5s3SugSbwT6dT2vuGaI8tpxIxed1NuBARbsSQlPK07MRJpTLVmqapHQOEA7ypQo6n589PL6%2Bg9aZvwc',
        },
        {
          title: 'Replenish from warehouse',
          icon: 'mdi-package-variant-closed',
          link: '/reports/measures/inventory_transfer_suggestion?report_query=eJztWMlu2zAQ%2FRVBpwbwoT304lvjokDQBW6W9hAEwoQay0QoUeDi1jD87x1SlE3Hm6wcetHFEGf43jxRM9KDV6nhRmA6Tn%2BDwrm0GpNbrAVWXM9LrAytmCzpKgfDZaXTUcrmoMz9snYoWs5BT1wkHRtlcZTqufwTAjMQ2kVQIDOYT0DlEylsSTTjx1VaQek4pkrmlhnHLHMXuDFYPrqf5DNqpnjtKj9RnjRAKGzwr0MIy%2FV3qGteFRR8XmZ1IFuPNvy%2FQHGoIv7FJnCOsN0Zsd19fdgyhWqZfrEd2OLdEeM1KE%2B3x%2Fq8SXRlbhERezjd5M6AsfqA9Dbe%2FXBbzIEqnmCvhmmiF1TwiPgZUgNKtWVu1skPl%2B1EvGgIIsqHiptkIvV%2BY2SWUhlrUhE3s0phxZbH2iTCxQ2DQtC2ZKo4i87G761DrEuRCBCx38vkm2R%2BNtvTCAUejcxESGVud5cJeo2JS31aABfwLDD5aeluuVkm76LyV0dKNzdkMl7RMzBSLV%2FpyJHxEsRJKXscsa6bit5Q7oQvksUD6k269kliYV%2BkQgaaZg8E6k6qZgGSaQfpoWiXYLffc1TaSPaCeeKav5si62C%2Bs%2FvIidCxllssgVfumfVUpVqC3speMew8NyXLo1M1o%2BTlc7WPOjdZOyKujgroO11nWM7MV0dxvWfsHM2pKeuordeknaLYeSsrqPQMlfIPNbR1R2EmYB30ou4%2BR3N4AN8itd8UnuQ4dIqNqvhNEBKXDf8OKF0%2FjdISQVvlQJvO2pxbpm1RoHYaHT8nC6zddeMmtg4SZ2CFyQhVBEM848KgIodLFWq%2BkCaT3sH6bzjt5xXmtK0GBaVutrUOmU6jlsp5iMElDy55cMmDSx5c8uCSB5c8uOTBJQ8u%2BT%2B55BoKDBaWHOnKr9Pxh1HKyXzqKaqpD3x8Tz6WzOv1MnhaunbOlFb%2Bf2AKFUraus37RdjgvLjV5k5G%2FxqXZKt5FFmPtm4Mi9IPYp6OqSoDwawA559LNPTtD66a5oFMNtd0fnTnJHG1Xv8DZjwqYA%3D%3D',
        },
        {
            title: 'Replenishment by model',
            icon: 'mdi-view-grid-plus',
            type: 'group',
            items: [
              {
                title: 'Just-in-Time model',
                link: '/reports/36/inventory-replenishment/622',
              },
              {
                title: 'Fixed time period',
                link: '/reports/36/inventory-replenishment/627',
              },
              {
                title: 'Fixed order quantity',
                link: '/reports/36/inventory-replenishment/632',
              },
              {
                title: 'Min/max inventory quantity',
                link: '/reports/36/inventory-replenishment/602',
              },
              {
                title: 'Min/max stock cover days',
                link: '/reports/36/inventory-replenishment/601',
              },
              {
                title: 'Replenishment for bundles',
                link: '/reports/36/inventory-replenishment/672?report_query=eJztWW1v2zYQ_iuCgAEbbBW2EtuJv6XJBgxr16xOAwxBIDAS7XClRFWkPAtB_vuOlG2eaNmzHSxDgXwJIvK5e-6F4p3OT75iilN_7P-azWmmRFF5n2nOacbkYwoLftePH0mhbqpco-DxkchLveKPVVHSri8fxd_LhSnhUq9QTmNFk0tSJJeCl2km_fHdk5-RVOu4LkRSxkazSAy1oumd_uNdURkXLFdMZPewnxBFlsSKLrQEL5n8SPKcZTNYfKiifKnsubvWf0sKRjKkf75e-DeFKyTSNvnti9W0ZIvk1_Ig84wAUvqZiiKhhfdHCWxMVZbhjq3yEBU4D044EhqzlPANyi3SbdxXRFHEW9TLEZBQl6xGNpkwHqv_kjElvYngCVIu4TH6tnQ2yklB0j0dapHcZNMgLwefEoJDSea0IDMKJjJeRaWGRkbfIQbsVoJtuUj-KiUce688yihJOJWRKmiWvNQ0pAob-IGSxLthKfV-BJvkT8gqODWJKCIOiEgBYk8LXLHGi0OmVFXeRIn4Kz4KZjmSehkE55TvexI2BNtO9bVg-NVfH-tcr-_J1JDBJPaObHlxL2JVEu5tYvZk3SrftCAWKeDbb456L7KXwLfDTNihARtxBYfHE1MPl4yUsEwrQYk2idIHDanLOck0bt-c79KBTfoI7GmZtkXPWgSuHR-bduGGDWSxhw1k8QIbWoXb4mDeOu9SzM1FX0knCnVcY71tontADFzRtgjsYgcXjmVvEW3z_dO20qrNr9_sI3LfFGzzejsvGH4c74Yg5v2FLaDYbGWd6u3jeNtE2y7byyrmbT1ErNcPvGyNjFva4QxJfJuvKp6udXAKpHujx2UBRS-utpbKtaD_fN_1U0pkWdAdfRNoh7KWSWhI64bO9pJSQc9bV72xH_bC06B3HoQj2IGi2Fjvh0E41KrolJRcRQXJZnrzJIXFKeOKFrg_th2U91B578ssgWq-tZl6MPs6DnPCSwDc-T0ffBPQehDwCCRmqj0VOgQ5mwsVCdNy1_296WsaDfsEOnzvRuTWBiXyDDNecK45zfOSRELgzeFo6ZKZVLcaWrOwxB8Phl3_A3mAmj72BwC5rTXD__pEGMTIIvo9BIGHNebMYkKMCRHmHDFhzMBihj2L0a5ZkH7SYeOCJOZkmU8edGp_XsS81FueKFUgpoG5sbykcQvCViSmEapudCWGo5qJlwV12Ldu_C6QF6B47WpoMX-aY7YCVfC009V1v3tjGs21d7j7RN70XWe0xU1XsjJ9gHeh1RmU2k6_1_sBZ_edTR3Kbue8geq_O1-j-ijBnTMHdmZhKICdkQMbWRiKYWfowIYWdoJgAwdmD3r_FMFOHdiphQ0Q7MSBnVgYerE6oQMLLWzUCG8T1rcwnIUmymJQCoKmqh5KQYhSEIQOzKYgRCkIThyYTUGIUhCcOjCbghClIBg4MJuCEKUgGDowm4IQpSAYOTCbghClIDhzYDYFIUpBcO7A-m2v4r0dteiyJQpd2r7zccv_ORlpFt6JuWtx4cVf2GZzT-oNue2k-1f7g2cntSimXpKZScX2YQ30Zq2srRndJvs2IfouJkRvA47lJbQcZ2wOyl51qvG6I7TXHQ--ysDubSz0NhZ6Gwv9t2MhPUTQNaaeIUDr-WSe4UOg6zPoMuU1La7NwgBafgld6vtKfw9u7-fua5juTgGof2WElVkhytxIrh6W-3qOA1V1ItAvkGnJFUMrz1370x2daZZIt9xgT0x4XHKiW-iUqoLFslYJdQLKN5Miq3_hGj89P_8DSs_0ZA',
              },
            ],
          },
      ]
    },
      {
        section: 'analytics',
        title: 'Analytics',
        icon: 'mdi-chart-box',
        items: [
          {
            title: 'Reports library',
            icon: 'mdi-file-document-multiple',
            type: 'single',
            link: '/reports/37/most-popular-reports',
          },
          {
            title: 'Inventory tracking',
            icon: 'mdi-package-variant-closed',
            type: 'group',
            items: [
              {
                title: 'Inventory tracking overview',
                link: '/board/1460',
              },
              {
                title: 'Inventory on-hand',
                link: '/reports/31',
              },
              {
                title: 'Low stock',
                link: '/card/view/1276?report_query=eJztWG1v2zYQ_iuCgAEtYhXWi1-xL62bAcWaNkvSDkUQCLREJ1opUSUpN0aQ_76jJJsnWU5tZ-iX9YthHZ97J--OfLBVohi1p_a7bEkzxcXKuqA5o1ki71IgWHNByVcn5t8za76yzgWPi0hZn4lISKbsnh3dEaGuVrmWcfnp7Oz1xReg3hE50wv2VImC9mx5x7_XhAVhUlMoo5Gi8YyIeMZZkWbSnl4_2BlJtahakVbA49I-RdNr_WO9pTISSa4Snt3AekwUqfUreq85WJHIM5LnSXYLxPkqzGthj72NfORAJX-5IfxI4BqJpF3--clIqrWF8mtxkHklAxJ6QbmIqbD-KkBbolZGw3WyTlYocLJa4YhplKSEbancwd2l-y1RFOkVFTkEJbStrEI2NWE8Fv8pS5S0LjmLkXAJn-G32tkwJ4KkezrUwbmtTYOsHHyKCQ4lWVJBbimYmLBVWGhoWMo7xICnhWBbXsf_FBK2vVUcZZQkjMpQCZrFzzUNicIGvqcktq6SlFovwCb5ElkFuybmImSACBUg9rSgzdY4OGRB1cq6VDz6irdCSQ6lJgPjkrJ9d8IWY9euPucJPvqbbZ1r-p6aGjxYiSmkHQf3daQKwqxtzJ5ad_I3LYh4CvjuylGthaYIfDvMhCckYCPewuax-MLCfSUlSaaFoESXidIbDYnLGck0bt-cPyUDm3QG2tMi7YqesQhcOz423cwNG8j9HjaQ-2fY0MncFYfy1FkzviwL_Uq2olDFNdLLZXQPiEGbtSsCT2kHF47V3sHa5fvHXa1Vm1-d7CNy32Ts8nq3XjD8OL1bjFjvH8k9NJudWhd6-Ti9XaxdxXa2iljXDBFp-oHFtuRpt3bYQxJX83XH070OdoFsV_SoEND0otXOVrlhtB9venZKiSwEfWJuAunQ1jIJA2k10JlZUiqYeauuN7W9vhc4ruv0A1iBpojoA6fvOX1fi6ILUjAVCpLd6kU_BeIiYYoKPB__R-V1SVgByGvbDWzwlcMoQgAEvKwc5zpyg6L_gSrrkFFuo63fUnarfqhrffOAiKoCFYvN8Lymb5RAr0yWtKWJfuuYyXWa82TJVcjLawXQAVWa3biUXMItxrriudGueJ41dDKmFZbftQYJoWa0Qytsv0SqzxpaaUliezoY9uz3ZA5zy9QeAORzJRn-61iUiJFBuH0EgY8NZmwwHsZ4CDNBmjBmYDDDvsFo1wxIf-mwMU7i8vSU1zqUr9P7iBV6yeKFcvjCKfeiFTcqPSyFfBGibUrXbDiqGX9eUIeuceMDR16A4I2rnsF8oRKBVvD1pKubmf6qHKY33uEJGx-1tjPa4qYrWZHO4bx3OoNSe-L2-7_h7L4yqUPZPZk0UO6ryQblogSfjFuwsYGhAJ6MWrCRgaEYngxbsKGB-Qg2aMHMRncDBAtasMDABgjmt2C-gaGDdeK1YJ6BjRrhbcJcA8NZaKIMBqXAaYrqoxR4KAWO14KZFHgoBY7fgpkUeCgFTtCCmRR4KAXOoAUzKfBQCpxhC2ZS4KEUOKMWzKTAQylwxi2YSYGHUuBMWjC36yjemOck3Zq50O1715OS9S6FJm9OaVJ-bnea__PT0899n_l1Y64H5nqA2355-anX5F_PZT98LtPzokZV4yJUmYfyG2p-z06gUMhzKs5LwgCqu4SC9GalW3_3GbqpILq4AEg_mAPlVvAiL7nWH_W6vpJATC45ekxP4caQIMojxIawqGBEl8SUKpFEsuKFrQhqE8mz6lV2-qDBnHFxUTA0Zti-6w36wYQ4Cy8iTjAMIofM4ZYyHI_iaD7xPeqSMge60M4OvHD4jaH8d7s2Af6L2_kLbzDoWV7QL39erhdBQp08wb_b-1zM1h3FDoLRZO65vjN3x74TLAIP_nljuIxNRm7sDiIaDY725drvuUHzlvHm9Orv09MPnW7Vvj3HrfK6ks1qawsgTf3HfwGfhKg3',
              },
              {
                title: 'Out-of-stock',
                link: '/reports/288?report_query=eJzVWG1P6zYU_itRpEmbaK6aQAv0G4NNQrvcyyggXSEUmcQt3nXiXNvpqBD_fcdJW5-4SWmLtGlfEDl-zutj-5z61ddMc-qP_K-lDsQkUFok371rKdIy0crv-ckzkfp2XhjM-O7q6uzmG0ifiTo3C_5Iy5L2fPUs_l4IJoQrI6GcJpqm50Sm54KXWa780cOrn5PMmFp4MA5EagSXmmYP5o93QVUiWaGZyB9hPSWaLPxr-mI0eMnUFSkKlk9B-DSPi4Wxt97K_j2RjOTI_mwleM_gEomsjf-4s5YW3mL1vdwpvEoBGb2hQqZUen-W4I3pufXwwPIZzbWQ81jSgtOcqecMBE45UpqwjPA1lx3abb4viKbIr6zFMTihrrMa2fSE8dj8Xc608saCp8i4gs_4xyLZuCCSZFsm1KK57s2AvAJySgkuJZlRSaYUQmR8HpcGGlf2dglgsxEcy1n6V6lg23vlXkEpwqmKtaR5-tHQkCkc4GdKUu-WZdT7GWJSv6CoYNekQsYcELEGxJYRuGqNg0MmVM-9sblV8FaoxHF12YDijPJtd8KaYtuuvhYMH_3Vti6MfEtPDR3s5HJ5utoO7lmiS8K9dcyWXjv1mxEkIgN8-81Rr8X2EvixWwgbLOAgLmDzeGKCQr2hGWG5MYKIrogyGw2ZKzjJDW5bzjfZwCFdgfeszNqqZyOC1PavTbtyIwbyskUM5OUDMbQqt9WhOnXeuZhVF_1cOVWo65qY5aq6O9TAVW2rwCbvkMK-3ltU23L_2tVaTfj1yd6D-6ZiW9bdfiHw_fyuKWK_v7MXaDadXidmeT-_baptl-35POFtM0Ri5DtetpWO29phDyl8my87nul1sAuUe6MnpYSml8w7W-VK0X977PkZJaqUdMPcBNahreUKBtJ6oLOzpNIw89Zdb-RH_ego6J8G4RBWoCk25GEUhANjik5IyXUsST41i4cZCCeMayrxfLx_l5kRXgLqwe_7kJ2A4YMABtR4NcC1sIHq_YVqb5fhrdPZVHf4AljBZkLHoprwYQmAlb3G74Mx_KDwbkVhQ9CiyLHHM86Nz-p74UQBz9xJcjmUM6XvDbT2wlJ_NBj2_M_kCUaIkW-Yua8tw_-mIBXi2CLCPoLAxwpzYjERxkQIc4o8YczAYoZ9izGpWZD5MmXjgqTVRq5-YSHSfntJeGmWPIF_xKWNSxeWYjGJUTOlSzVc1Vx8rKjD0KbxRaAswPAq1chivlGFQHP42pjqary-rebaVXZ42EXZhG4yJuJmKnmZPcHRa00GUXsQ9vs_YXY_WeoQuwenDVT46XSFChHBBycO7MTCUAEPjh3YsYWhGh4MHdjQwg4RbODA7EYPjxDsyIEdWdgAwQ4d2KGFoYN1EDmwyMKOG-VtwkILwyw0URaDKAiapvqIgghREEQOzFIQIQqCQwdmKYgQBcGRA7MURIiCYODALAURoiAYOjBLQYQoCI4dmKUgQhQEJw7MUhAhCoJTBxa2HcVH-7JjuqSQppN2ve54lxn0W3tKWfWJjvP_6xXov__l9---qzSeBJ0Rfq2dbOlyTa8xzApJE6K0x2E486o73fvRMtQuYLGBLd45dh1uN5jojkhSIKek74RCMlGuPTN0DqXdFupZyQys9agEJ-y1-ob7ruczOCTqmsrrSjCAm03BYfx1btreOxV6rLHmhAHaPOCCZCpFWVTqy4_FuhmRoeeOBXrczWCCZUjy1rOvonRqhubYXC8QVEJ4UnJirouMaskSVZtMRAb7jSmR14-Ho9e3t38AjGCQeQ',
              },
              {
                title: 'Inventory remaining days',
                link: '/reports/212',
              },
              {
                title: 'Inventory movement',
                link: '/reports/291',
              },
              {
                title: 'Month-end inventory',
                link: '/reports/350',
              },
              {
                title: 'Inventory value',
                link: '/reports/595',
              },
            ],
          },
          {
            title: 'Inventory optimization',
            icon: 'mdi-cellphone-cog',
            type: 'group',
            items: [
              {
                title: 'Inventory metrics',
                link: '/board/337',
              },
              {
                title: 'ABC inventory analysis',
                link: '/reports/672?report_query=eJztWW1v2zYQ_iuCgAEbZhW2HDuJv6XuNhRru6xOAwxBIDASnXClRJWk3AhB_vuOlG2eaNm1HQzYsH0JwuNzb7zj3VF-CjXTnIaT8OL1NGDFghZayDogBeG1YirshekDkfqqLg0Ilg9ETQ0lnGhZ0V6oHsTXJWFOuDIUymmqaTYlMpsKXuWFCic3T2FBciPjUoqsSrWRLDJDeKtpfmP-BG-oSiUrNRPFLexnRJOlYk0fDQevmHpPypIV90C8q5NyKey5t5Z_TSQjBZK_WBO-JXCFRNJmv35ykpbaEvW5Osg8y4CEfqRCZlQGv1egjenaabhZhyCRtOS0YOohB4J3HBlNWU74hsot3F263xBNkV7ZkBNQQn1lDbKtCeOx-E8F0yqYCZ4h4QqWyZels0lJJMn3dKiDc1ObAQUl-JQRfJRkQSW5p2Ai43VSGWhi5R1iwG4h2JaL7M9KQdoH1VFGKcKpSrSkRfZS05AobOA7SrLgiuU0-B5sUj8gqyBrMiETDohEA2JPC3y21sUhc6rrYKZF-hmngiUnypCBcUH5vpmwwdiV1ZeC4au_TuvS0PfU1OLBSt6uy2PHxb1IdUV4sInZU-tW_rYFqcgB3105mr3EFYEvh5mwQwI24g0kTyDmyNSPNCesMEJQoG2gTKIhcSUnhcHtG_NdMrBJ70F7XuVdp-csAteOP5tu5pYN5HEPG8jjC2zoZO46B3vrgqlY2EJfK-8UmnNNzbY93QPOwGftOoFd2sGFY7V3sHb5_tu21mrMb272EbFvM3Z5vV0vGH6c3g1GrPdn9gjNZqvWudk-Tm8Xa1exndYp75ohUkM_sNhaHr-1Qw4pXM1XHc_0OsgC5Vf0tJLQ9NJ6a6tcM4bPt70wp0RVku6Ym0A6tLVCwUDaDHRullQaZt6m603CuB-fRIN-FA9hB5oioo-i_iCKYyOKzknFdSJJcW82hzkQ54xrKmE-BntKthA6EXb-bYZtO2S0puf1lHFl2_v6bHDP78Egyyug3oSD8Ha5Wh4RZ8qbhIsqvwMLenbr2kAbhSwLJ2e98B25g1Y7CX8c9PvfAeq6ER3Gr_o2XAZ2jmDnLdTg1fkaNegj2JkHO3OwAYKderBTB4sRbOzBxg42RLCRBxs52AmCnXiwEwcbIdjQgw0dbIxgsQeLHey0dbxt2MDBcBTaKIdBIYjaovooBDEKQRR7MBeCGIUgGnowF4IYhSA68WAuBDEKQTTyYC4EMQpBNPZgLgQxCkF06sFcCGIUgujMg7kQxCgE0bkHG9gqwQXJbBWxz1tUoX56THlltgJR6UjMI9udgqzV8WArEfMETTJ0xYbvaSH8i6oAYatrxzNz86KOUcQ-COQFCF75Okbh-oMqBKphtdNVmDuXrpbLgo1cXJNgOPk7XBvu4drJ0a7NHsTX4EqUzh8tygI7cMH5yzwYoVwcIdtc7o9QGg76-Ia7IjtCZSDGmBhhUBkYYczIYcaoBhjXHMisOs7q1n3SMe1RSNNC_-WfdZbWBr9IkuERZvXB5t7Q9zG2xYA1fKA6sE05SEWhJburbFvHL2HTsfGmp6-kMm2GEP8l7DP6emcGgVQVVDcfBfbUsMb_s16_xrX_7vel_9_-3W9_Z0pTx3Yk5fSAJ0Mnc_sVpCFmG0oxeV9dLVHfrCEBSdMqr3j7A-5mVUgA18COLixOhG0MpcnU5n0Ctf_JrmH27IUMyry6pPLSEkbQYRS0idd1864x_5seACvbUYB0L0VVrvbtYgkwzzJ44MwE-kEBLNAMUZ7Ba8JTa1eW5BTMTVXDC0kMF4cpMN1-mZ48PZt3VdH8DjEVFbg9GT7_BWoVZ9s',
              },
              {
                title: 'Zero sales days analysis',
                link: '/reports/56?report_query=eJzVV0tPGzEQ_isrn3MAJGibG48LamnTBqjUCK0muyax8NpbexwaIf57x97drJNsCCkC1AvC8_i-8ew8nAeGAiVnffaLG50MQXKbnMHcJscK5NwKy3osm4LBy3npzeg4BXvqJayPxvEes1N9XwtuQVov4ZJnyPNTMPmplq5QlvVHD0xB4TEGRucuQ4-scy84R16M_J_kjNvMiBKFVjekzwGhJkb-x3tIJ-wFlKVQExKO52lZgz32FvjXYASoCH-2EGwBVE7KCKgONBkioLMtXs2Z2kb-_Dgbn4hl-PmqA_rO7YhLDhHoCZiAuAY8Xih2AG-cOnITENZYsJLuQBE84o_IVa5Ni1ydk69e-yzgWQUQh-zGUtgpz6nCsSPostGneaWPWGrJMssGx4hypataztFQ6vsgW6lz5YoxN12F2WMgBVAnseOY4lzRTVGbefLdUZELnEcsxxk6kMm6zQprzjNRgFy74UZ_tjWaa5COPxXKqba4EkbmjOEqm2-PwztviuEHRxByLYBY_EzeJ9L-BSwm30zOzUo1jYKm-ea4StVZrpJcUutd1iroSglsbtswOJKl2Q7pWzhsStmQS0mmycCILL7LkvzlSbsAMxEqwl90kNG3FGIR9Cs8JTcZV-tJ6_RdvuBNjxUcrDMex_qOs6izu6SerqLgytKqqQdGuyX4LTiJqQE1qZferZBIbRltsX_vu1kozP6I7TEKUNP9gGzIbYLdXdkxdu22lbQgoVDEjK8w8d8dVenTVYqZxlSHDVzdvAQDxdL-HtLCTy512bKjLtUSp5SeMJxrBksfTW4Y3cJi6MqKReSsf3jUow4bc0lWh2RS9bL_3-ciWHxoLfb3IhM6LGw-tjYHsc1BZPMpYoptDlubo73Wxl-tNfInnzapIQ9VGV5AXtK8gVLDS2189_2_76BXeaG81QANr9mfAqfa1agv2sLvv3nfa9u-2oZ9vW33ihvubbdaGM0w4fVkpjHyEM6sv99jgiaGHXAzCIJDGlaWJs7J3E_iuMJvKoWfLaTyP95IMjHalcG2OdR6vzudxaGOftgVtBVFJHnsteOAT2ibYurnJUWQgcycBD8AC46UW1tBZrqghSKsVlWj9h8eH_8CrN_upQ',
              },
              {
                title: 'Aging stock',
                link: '/reports/562?report_query=eJzdVttuGjEQ_ZWVnzcS0JI2vBHy0KitSkuSFxStjNdZrHjtrS-0CPHvnfEurLmpSSVUtS8Iz-Ucezw-syvihJOcDMiwEKpIJk6z52RsdO6ZsyQlbE6Nu1tWGALLObUjtJCBM56nxM71j8bwRKVFC5ecOZ6PqMlHWvpSWTKYroiiJWI00IisczTcOl5O8Se54ZYZUTmh1SP4c-poQ-z4T8yQXtjPtKpgo2CcLbOqAVunW_wHagRVEf5ia_gNoPJSRkCTj_ctSEOU2Wf_qp2FhAj0mpqAeAA82zpeAb5Jigia8iZjP5PCznme3FB3hK_a-LO89ke0jWWX9kRiRH2vhLPJRMu8pZt6NGYWjHtXmnMmSioPeNoEcFEpqMXejHnqFv2ikg9UxVRD5jyVya1acOW0WSZfPdy7cMsXMp_MP7WRT9S65BtnXCwO6jw1jT2UaX8HRwq813272KG0EbgEb7Zl-P7iIx7knTrasAgnWsakW9semfLljJvDckYQRznwUMlIW7fXLhkD2x4H88ZwxZZH2yUknOwWLiUK29gIFt_Pjv2FbHhHOzSPKSk5td5gFkUBzSx2J8KJkisLUlY_2VaFrAO1zJwIu-t1em8vut2LXgc8XOW79t5F9wqh-BP1Ei6OqgKdbzrY9k9COih7JK1_9DAWVHqImpIOgdPoihsKMZBWuOM9hYeuxEK7TAeprudCRQ0td4R-ApMhudNVuxGnKxUzDqVEzrBuSCyUUJ5QQWHdA4bWLCIng_5lCg9lxiVE9SHkoUaG_9gAIeJdG9HtRCGw2Ma8b2N6cUwvirmKmOKYfhtz2Wlj8GhtEK6wbFLTPDRSGJVo2QxLeJSVNtjJ_-7A_B_k8FwSeM4x-VdH4_n0_IwaHiSMFrxRMHhuq7Amg25KBLwsO-ZmHAx9eNQWXub1EhUrboDH2oFvEFz4NQyWwmhfhdjNovHjpPDWTXT0pVyCqIvIsk7b70xewPhwGeoK7IBRybykKBQld3BaW0MyXYLwCqtV_TU2WK3XvwCqa_az',
              },
              {
                title: 'Sell-through rate',
                link: '/reports/186?report_query=eJzVVlFv2jAQ_iuRH_YEUuk2aeOtpXuYplWsrHupUGTsa_Dm2Jl9ZkOI_75zEiAQosJDW-0lku_yfd9d7PucFUOFGtiQTUDrPs6dDdk8ueMIyWyZjJ2VQWDygzvFDbIeE3Pu8PuyiBBazrkfxQgbogvQY35u_9SBR659jIAGgSBH3MmR1SE3ng0fVszwPHLUCpHZyhj4jJA_xEdyA144VaCyZkp5yZHXwgh_I0IH5b_yolAmo-BsmRY12bq35W9UXvEvtoEnCE3QukE0-XK_I6mFUv8rnFVZCWiQXnNXMraIZ9vEGeQbUENgs4ET5Bj8kQY28XN6qDBHVEqClgZW0TMUSkRzE8FI63bM1Tq5jdmTiBcVQXM7D4_7jv2BjqxO61zqKHdw_ApwAkxbqIWjN7hWnA48u9rbdsiUMQRKvgU6iwqXDfXZJpn-rpMH8hKEyrlu99kCdunfAib3RqFPJlbLhrYB3IJTT7kTpSMuRMIS1CVbSd4BBmegKevq0Lkdt3BPKQtQC5DJm-RK_gwe94qo6nf1OydWsA_qkv9kZMdmQ5k5s-_oTB1KV4us3NlkZD0eNJcKih0oiOAcGLE82lgJ6OopKsUhio2NnRLNAdqLn6jYamraYzlwHxx0jJZUORhPt0M941tjJ4NyZCKqrPPy4vJdfzDoDz5Shj73fvyyP_gQqeCRB43EbLKYfHsR9_JRaQRHtxWVUqiFxdSWt1F19RXc8dxX2c0lRyehsC5-uP_4onsRZ3ze6XgNr31Bf31ZT30FH31eR4vWUvAM6nGmMV2VazYc9JiiifRjcOMy8P6Chpsm-npJs3zkQE6rdJxgeiH-A1Mko3NelIjNos5HS6PPNbGN_-OcfEc1Iuve7ucMMnI4TJVkQ6pDcC2C5tFmckCy1tp8hM3Ji5S3JpVxtIar9fofDz0W0w',
              },
              {
                title: 'Inventory turnover rate',
                link: '/reports/345',
              },
              {
                title: 'Inventory to sales',
                link: '/reports/642',
              },
              {
                title: 'Stock availability',
                link: '/reports/668',
              },
              {
                title: 'Stockout revenue analysis',
                link: '/board/372',
              },
            ],
          },
          {
            title: 'Sales performance',
            icon: 'mdi-trending-up',
            type: 'group',
            items: [
              {
                title: 'Business overview',
                link: '/board/117',
              },
              {
                title: 'Sales overview',
                link: '/board/64',
              },
              {
                title: 'Daily sales',
                link: '/reports/measures/sales_overview?report_query=eJztVl1r2zAU%2FStGMOjAYUm2tGnethTKYP2AlL6EYlT7xhXIktBHuhDy33ev7NZKs47svXkIuUfnniNZvodsmRdeApuxCy7kJltwCY7lrHzi1t9tDK1g%2BcTdnBA28zZAztyTfu6AFZeOEJBQeqjm3FZzLUOjHJstt0zxhjRura5C6UlZVwT89NAs6Su7AFdaYbzQ6gHXK%2B55Z%2BzhN3XIINwVN0aoGsHHTWE6sV3%2BVj9beO6D6206auFe8OPlX3r%2B4hIFDjx8i%2F6HQ%2BxI9O9BVdr2ym2dXdPqUcLrVmB%2Fyyvhsytua6Gyk0urnSta8Et2Db6IN%2F6591zud3x6cycGbAnq0NzErqKJXekGomPWiZ6gY%2FuOZYNsfnO5eNf4jW0ZrAVVbg5895pS31enxOEVO1a9F0mUcd%2BpaKnro%2FWIy3YPOWuAu2CJ60i%2B0GuwawHPpCMaUA6nob3SipMMvosW3xcRNzAejr8NhtPBaIoreOP7%2BPlgdEoysOJB%2BsJyVdPi12GF6EpIDxYnE%2FdgxFr7QsfJQ0JQ2CIUEM1wy5u9AV7gxGd32vQH99oorNZcBiyX7LuU7KGru%2Bfg8NTynVdXOH9P1NZFVGw2Oc3ZL%2F4IElkTpNy3yvibHn5knPWM0TChYPHKmfacccoZJ5zzxCnlTHrO6bDn0NF6ElV0h05bf2MrepzsnD50LM2reNUxFiOrC8bCgsGGovwIx49w%2FAjHf4Wj4TV0uYRzso01m41yJnAk3C3Y2whMhu0M%2Fti0eUa%2FaV6witOHUG11MC%2FrsegIFMHB%2BYVO%2FsI0GJciQXZ5PyFQYyj7goIBXUsuyyA5TXUD3orStZKlbjA5hdMKY9vjFre73R8EUyGD',
              },
              {
                title: 'Sales by geography',
                link: '/reports/measures/sales_overview?report_query=eJztVl1r2zAU%2FStGMOjAYUm2dG3etgzKYP2AlL6EYlT5xhXIktBHuhDy33ev7NROso7svXkIvkfnnnNl6V68YUEGBWzK5lyBz1jOxDN34X5tCcTwmfsZIWwaXISc%2BWfz0gJLrjwhoEAEKGfclTOjYq09my42TPOaNO6cKaMIpGxKAn4GqBf0l%2F0AL5y0QRr9iOslD7w1DvCbMlSU%2FppbK3WF4NO6sK3YNj%2FUz%2BaBh%2Bg7m5Za%2BB1%2Buvwu5y8uSeDIIzTofzikjJ7%2BA%2BjSuE65ibMbWj1JeNUI7Je8lCG75q6SOju7csb7ogE%2FZTcQinTkHzvPxX7Gh4MzseAE6GNzm7KKOmX1C0iOWSt6ho5Zc8kG2ez2av6m8YGtiM6BFusj372kvu%2BrU8%2FhFTtVvRPpKWPdfVFhqpP1iMu2jzmrgfvoiOtJvjArcCsJL6Qja9Aeu6E5UiED6eBldHhhZKpgPBx%2FGQwvBqMLXMEj38cvB6Nz0oEljyoUjuuKFj8PS0SXUgVw2JpYhJUrEwqTWg8JUWOK1EA0yx2v9zp4ji2f3Rvb7TwYqzFacRUxXLBvSrHHNm5fhMdtqzfurvThgaiNiyzZdHKes1%2F8CRSyJkh5aJTxmd5%2BYnztGKNhj4LBK%2Bei44z7nHGPc9lz6nMmHed82HFoax2JIjpEb1y4dSW9TnZJP9qW4WU66zQXE6udjIUDiwmFeJ%2BO79PxfTr%2BazpaXkE7l7BPNilm01HOJLaEvwN3l4DJsOnB7%2BtmntEz9QtGqfsQqpyJdreegpZAMzj6MDe9b5gax6XsIdu86xCocCqHggYDugquRFScurqG4KTwjaQwNU5O6Y0ucMNY4ma7%2FQPA3yAL',
              },
              {
                title: 'Product sales',
                link: '/reports/measures/total_sales?report_query=eJzNVl1r2zAU%2FStCMOhYwpJs6Ufeuox1hbXrcNaXEIxqK45Alow%2BuoaQ%2F74r2Y7luIUUlm0vIbo695xry%2FdcbbBhhlM8wTNZoK8sW6GIcKrRnZKpTYzGPZysiDKzdeFQsFwRPXURPDHK0h7WK%2FmrCiwJ1y5COU0MTadEpVPJbS40nsw3WJDccVTUjlmmLnBtaD53P%2Bgz1YlihWFSLGA%2FJYZUwoY%2BuQxumb4hRcFEBsGHdVxUZNvePj%2BKDDFWNzIVNNZ1%2FHD6OucZFU%2FQ0TBl9BUKPiPgv6cilaphLtfo1u0eRPxYErRLXjKDbojKmEAnV0pqHZfB9%2BiWmtgf%2FdtGc97OeLN3JgVVCRVd8cJnxbnPCgvwiqgiPQHF6mPro%2Bn3q%2BhF4T3ZxCpFRbLu6LaSQt2dUqCwix3K3pAEzFB3SJrI7GA%2Bh8XbRQ%2FnlGir%2FFFKQ3isq0pTllOhoRXaXzr0l4Fuiw3zFYwGo4%2F9wUV%2FeA47cOSt%2BHDQH545KroklptYEZG5zQ%2BDFKJLxg1V0JpQRMEepYmlbz0AWAEpTFAHK4gieauDI2h5BIbRPLmRhYDVI%2BEWlnN8yTleVOvqRWh4bP7Ct8u0uXfQUoWleDI%2B7eFv5IFyQI0Bcl8yw3%2F39j3irEEMBwEEFjvMeYMZhZhRgLkIlELMuMGcDhqMe7QG5FbuELkkqT9X74EuUrtgrGgh4bySF50QXeckC0yEVcvgRdWhTqN57yh3u%2BZ0NIv9KZjRKJI8DT7%2BH5YImCZrH9%2FjTmkCRfIOvYOiOjFUmLlW6DRtaSCvatuwp%2F6KJQSVo7udQ9YaQTlx5Z8HuuozmX%2FUiRqqdzPyhC5zaVuVN8FDeQOakD1aMY9AX2jw0c934deJ7KX9D%2BPmn8%2FZ49wdjnrdOealzY03MMhquoEDb%2FwaT4Y9zMATNbTpnQ%2BMwec1mPWntRtibbtZlFvOP2HT3X0hkilpC4%2BuF9W%2Bm%2BtWm0gG9%2BIcRjALItte83g0g2EPTg7DBmpICE8sJ2565NQoluiSMpE5TGOmpYjhPUDBm%2B32N%2FGL8rM%3D',
              },
              {
                title: 'Inventory sales matching',
                link: '/reports/measures/sales_on_hand_inventory?report_query=eJztVk1PGzEQ%2FSsrn4OUpA2FvUEqVahFpQpwiaKV2R0Sq157ZY%2FTRlH%2Be2e8G9Yk0I9TL%2BSAMs9v3nzYM2QrUKEGkYuZ1OCztc%2BuzBoMWrfJriWWK2WWYiDKlXR4u2mYSeZK%2BikjIkcXYCD8yv7ogEepPSOgoUSoptJVU6tDbbzI51thZM0aN85WocTsqpZLYH1bMaw6s5Iou2h7SAflr2XTcD65aFr%2Foj3dDQ6Fe8krhHrOf7KP4EunGlTWLJ7HQPiJRyEeNkUXJdW%2Fl05Jk%2Bivn4A%2FCJqgdSI0%2B3zXi%2BzL8d%2FDP2UWHRLRr64C57OpDWmKc8twUTJ6ULkJ9QO4owiJQyp%2Fa1HqLL6URP2Ts9636IF6GZwDU26O9JGFCh%2BFEv07o5CUrK4S%2BW%2BB2qtwE%2FGDABWU9AL0kT5Ts71jGqF%2F3E%2BnfaSLEgPVd8z5y6iv%2Br%2Bcwb3UAX4Xfmr94X292tEXncVuMRA1SB8cO8d%2BF9YUK2mqQu2pHEHVYDwNRvu6%2BjftkYa6QBVTHw%2FH70%2BGZyejMzoBkniGn5%2BMTlkKHmXQWDhplnz4bsiX%2Bag00jvL55RQo9YWCxsHkQjBkIsywLRGOlk%2FWxQz2izZrW36PqFtDFnr2L18Li60FovO7rrkqScaXp4k5TE2vo2iKpFPTgfii3wATawJUdp74e98bZHxoWeMhgmFjCfOWc8Zp5xxwjlPIqWcSc85HfYcLq0nscUX6q3DOOiEnfOHy7Kyig8hrt%2FI6hZw4aAhBxrmtyX8toTflvD%2FWcINTUi38mgEt9EW%2BWggFA2FvwF3E4HJsB3vyw1vtsOud7PPI0TH%2FMuLkKWzoYn8vdGd8%2BoPHmc2%2BVVW02ZWCbKjwqUug5a8KWpAp0rf%2Bpa2pm2sPP27oNIpt%2B1u9wtQs3BL',
              },
              {
                title: 'Product profitability',
                link: '/reports/measures/profit_margin?report_query=eJztVttuGjEQ%2FZWVpUqptKhASxp4a6iUVm2aSKR5QdHK7A6LVa9t%2BZIWIf49M2bDmqCoyXt4QMz4zDnjyxyxYV54CWzCbrTJvol6lV1bvRQ%2Bu%2BS2FoqiKpTesZyVK279zdoQGsMVd1PKsIm3AXLmVvpvm1hy6SgDEkoP1ZTbaqplaJRjk%2FmGKd4QR0tNzLqixHcPzZy%2Bsq%2FgSiuMF1rd4XrFPW%2BFPfyjChmEu%2BTGCFVjcrEuTEu2zff8t9wKrhL%2B%2B33iP4QqSJkQzX787khaocL9Ca%2FqLBYkpOfcRsYj4sV%2B4RXkj0WJwOE9nlxY7VyxS37IfoEvZlyCe981MD%2BsePfk5A3YEtRxFyZWFU2sShuIio%2FP6QQVs6iY9bLp1cXsWeEnsmWwFlS5PtI9KEp190qJwj73UvaOJGHGvlPSUtcv5iMs297lrAHugoWjg0Ma0YBy%2BOQPXzTOkcepKryIPQz7w0%2B9%2FllvcIYroKrD%2FLg3OCUqWPIgfWG5qmnxY7%2FC7FJIDxZHENsw4l77QscRQ0BQWCIUEMxwy5uDSZ3haGdoEN3evTbU8j2XAcM5%2ByIlu2vj9igcblw%2B84yF87cE3amIik1Gpzn7yRcgETVCyO2OGX%2FT%2BUfE5w4x6CcQDPaYsw4zTDHDBDNOlFLMqMOc9jsMba0DUUTX6LT1V7ai42Rj%2BtC2NK%2FibUf%2Fi6jWAQsLBguK8s0F31zwzQXJY2po3QenYRNjNhnkTODDd9dgr2Ni1N9N2vmaTOb4atpBpEFBAP0PwUxtdTCx4jFo18l9g%2FMznfxHadAmRZLZ5t3bhhoN2RdkCNhHyWUZJKdpbsBbUbodZakbdEzhtCrwCLDpzXb7AKM%2BG%2BE%3D',
              },
              {
                title: 'Product returns',
                link: '/board/347',
              },
            ],
          },
        ],
      },
      {
        section: 'integrations',
        title: 'Integrations',
        icon: 'mdi-link',
        items: [
          {
            title: 'Google Sheets',
            icon: 'mdi-google-spreadsheet',
            type: 'group',
            items: [
              {
                title: 'Introduction',
                link: '/spreadsheet-integration',
              },
              {
                title: 'Google Sheets templates',
                link: '/spreadsheet-templates',
              },
              {
                title: 'Connected Spreadsheets',
                link: '/spreadsheet-connected',
              },
            ],
          },
          {
            title: 'QuickBooks',
            icon: 'qb',
            type: 'group',
            items: [
              {
                title: 'Introduction',
                link: '/quickbooks-integration',
              },
              {
                title: 'Configuration',
                link: '/settings/incoming-inventory',
              },
            ],
          },
        ],
      },
      {
        section: 'report-scheduling',
        title: 'Report Scheduling',
        icon: 'mdi-bell-ring',
        items: [
          {
            title: 'Scheduled reports',
            link: '/schedules',
            icon: 'mdi-calendar-clock',
          },
          {
            title: 'Schedule profiles',
            link: '/schedule/profiles', 
            icon: 'mdi-account-clock',
          },
          {
            title: 'Schedule templates',
            link: '/schedule/templates',
            icon: 'mdi-file-document-outline',
          },
          {
            title: 'Email templates',
            link: '/email-templates',
            icon: 'mdi-email-outline',
          },
          {
            title: 'Email receivers',
            link: '/email-receivers',
            icon: 'mdi-account-group',
          },
        ],
      },
      {
        section: 'product-segmentation',
        title: 'Product Segmentation',
        icon: 'mdi-segment',
        items: [
          {
            title: 'Product segment listing',
            link: '/product-segment',
            icon: 'mdi-view-list',
          },
          {
            title: 'Product segment builder',
            link: '/product/explore',
            icon: 'mdi-view-grid',
          },
        ],
      },
      {
        section: 'my-account',
        title: 'My account',
        icon: 'mdi-account',
        items: [
          {
            title: 'My reports',
            icon: 'mdi-chart-timeline-variant',
            type: 'single',
            link: '/my-reports',
          },
          {
            title: 'My dashboards',
            icon: 'mdi-chart-box-outline',
            type: 'single',
            link: '/my-dashboards',
          },
          {
            title: 'Recently downloaded files',
            icon: 'mdi-download',
            type: 'single',
            link: '/download-manager',
          },
          {
            title: 'My subscription',
            link: '/subscription',
            icon: 'mdi-credit-card-outline',
          },
          {
            title: 'Importing status',
            link: '/importing-status',
            icon: 'mdi-database-import',
          },
          {
            title: 'Plugins',
            link: '/plugins',
            icon: 'mdi-puzzle',
          },
          {
            title: 'User management',
            link: '/users',
            icon: 'mdi-account-multiple',
          },
          {
            title: 'Logout',
            link: '/logout',
            icon: 'mdi-logout',
          },
        ],
      },
      {
        section: 'Settings',
        title: 'Settings',
        icon: 'mdi-cogs',
        items: [
          {
            title: 'Store contact',
            link: '/settings/contact',
            icon: 'mdi-contacts',
          },
          {
            title: 'Inventory replenishment parameters',
            link: '/settings/inventory-replenishment-parameters',
            icon: 'mdi-cog-outline',
          },
          {
            title: 'Incoming inventory',
            link: '/settings/incoming-inventory',
            icon: 'mdi-package-variant-plus',
          },
          {
            title: 'Internal inventory transfer settings',
            link: '/settings/internal-inventory-transfer-settings',
            icon: 'mdi-transfer',
          },
          {
            title: 'Inventory forecast settings',
            link: '/settings/inventory-forecast',
            icon: 'mdi-chart-line',
          },
          {
            title: 'Manage suppliers',
            link: '/suppliers',
            icon: 'mdi-account-box-multiple',
          },
          {
            title: 'Bundle product mapping',
            link: '/settings/bundle-product-mapping',
            icon: 'mdi-group',
          },
          {
            title: 'Multi-store settings',
            link: '/settings/multi-store-settings',
            icon: 'mdi-storefront-plus-outline',
          },
        ],
      },
    ];
  }

  public get isTestingStore() {
    const testingStores = [
      'dariustest2.myshopify.com',
      'the-best-mega-store.myshopify.com',
      '2dba1f-4.myshopify.com',
    ];
    return testingStores.includes(this.store.shopName);
  }

  public searchReport() {
    this.$router.push('/reports/0/all-categories?keyword=' + this.search);
    this.search = '';
  }

  public doLogout() {
    this.$emit('logout');
  }

  public handleMenuClick(item: any) {
    if (item === '/logout') {
      this.doLogout();
    }
  }

  public get isAssistyAdmin() {
    if (localStorage.getItem("loggedInFromHades") !== "true") {
      return false;
    }
    return true;
  }
  public isPaidUser() {
    const isPaid: boolean = this.store.currentPackage.name !== 'Free';
    return isPaid;
  }

  public isCustomIcon(icon: string) {
    return icon && !icon.includes('mdi-');
  }

  // Convert forecastingItems from a regular property to a computed property
  public get forecastingItems() {
    let baseItems = [
      {
        title: 'Historical sales-based',
        type: 'single',
        icon: 'mdi-history',
        link: '/reports/38/historical-sales-based-forcasting/609?report_query=eJzNWMFu4zYQ%2FRWBQIEWtbaSbMVJbtkUBYJ2u2ntBCiCQGAkxmGXElWScmsE%2BfcOJVkc0U5ioz1sDgE0fJwZziOHj34mhhvByDm5qtasMlJtgp%2BkYjnVhler4GET3FLFaWXIhORPVJnlprbwxc2nTxe%2F%2FwHWJ6ov7QA5N6phE6Kf5N%2B94ZEKbS1MsNyw4pKq4lKKpqw0Ob97JhUtrSsUQBbWsB4MBTW0D2jYP9YiGq4%2F0bqG5Mh51QjxMhkcbRMPFlQwHfzWgBNuNs7x3WOPyLRFZH%2F1iPtxqILlvKTCj0ZemU1QCktpqAhuKm50sJCiQLEba8w0GDO%2BrXVWC1pV4P3ADN70QV7uJ6RkVDfK%2BnCAR0eoDcNLVmkuK8A8bDJXbG2AtMzwdiFJlMzCaB7GpzDCqmJkj6MwnltX7JE2wmSKVis7OC3B%2BMiFYQoIhmxqvpYmk7XpwsFoTRUtR%2FQPrC0hQvBtQTf6O1e2oeZt%2FAnsDdGA%2FY5MI3Lff%2FZF07A%2BwcaFrJryAZKBxUllPqvCJkbiKLKVlbRoq9ruUsThRfFno2G7BksFC3epdKyb3jgkEvt5CK7NK1nYoVsL7SrAC3J%2BOiG%2F0AcmAPY9JPYNoG471yT5ELV7y8LOEOxshIo%2FnA2oOEKwUw926mAxgs092NzBEgQ78WAnDjZFsNSDpQ42Q7CZB5s5WIpgUw82dbATBEs8WOJg81F5x7DYwTALY5TDIArCsasIUZAgCsLEgzkKEkRBOPVgjoIEURDOPJijIEEUhKkHcxQkiILwxIM5ChJEQTj3YI6CBFEQnnowR0GCKAjPPFjcNi18OGdvns0FXC7BUtbuVBpZV%2Fg4XghxSGPYXie7BzJFy0pRsq6MKVpRHOHN4s5rinZUgjEJwqAdlWJM6jAnaDvZpTmQ%2FfKLd2b%2Fdut37%2B7gTLEaJmT57j18rWTR5Ca4KumKuQLz9hNx0OMc4sqw8s7%2BC35kOle8bff3%2B%2Bs9us7g%2Bql7Z8j%2F%2F6YHFj%2FfOCd9oEx%2FaY7KrJ3wdYkML4WLUja4XH4CtB33wueNgoss37wXv5u8N7pTjNsiBL8yhiXPXglyYB32y5d9eXxeM6WNzL%2Bw4geQXsXw9SY5EmZljUVnLfxYevz5X48KREpmvUJZBDVTAcgrlA1drzLr7T8m9J6bUU5bdfVOYkxB28kKysUmQwtGIuzg5N53hRMcNrOsgieKBeDdRW4aIHZ34x%2BYyqvzcfyrKpelfXsNsNGJ6gaP7So78%2FaepGWnsXfOitXeXiAnafcfj1auv9012ovMbxmDA7eL2qv86Pblzce52J0XXEptvHMJl6I%2BuE8OE7DnBRPCUneteI4rObIfGMG7zNBxgUf5opU0en9j6fTO8c2k10mvBv0I7e7VoA%2Ft4PFBu3mtkqntMe0eiyBMnttv0N0TwkFb6GumrltDGnWi5%2BPG6r33OmqvkKwyAbj9iQIsKyWbup2%2F%2FejH7Qsa2tNCop8vSnjicmR5mTgxwVbwmIbNBkoNssqpyBtBrcwqmQGudecSzh68e7mWFXQhA0t4fnn5F%2Ba4x3w%3D',
      }
    ];

    // Add methodology-specific items
    if (this.currentMethodology === 'combined_weighted') {
      baseItems = [
        ...baseItems,
        {
          type: 'single',
          icon: 'mdi-calendar-month',
          title: 'Monthly sales forecast',
          link: '/reports/measures/sales_forecast?dimension=by_variant&report_query=eJzlWltv2zYU_iuCnlYgD02CvvitTRAs6dpkcLqhCAqBlmibCEVqvDgVgvz3kRRliZE8SyXVAtpLUZ3r9x1eco6l51gggWG8iJcAQx5dUQZTwEV8EqdbwMR9WWiletwCfqEl8UIwCU9ivqVPVrAGmGsJxDAVMLsALLugWOaEx4uH55iAXMf4CzAEiIiuc7CBOj7NtBjZxwwIYLPVIiwR_wSKApFNSwqkoEuTap85pZiya5LB7w0YygRYaWYa7svJHsYdo5lMRQPgWsD8Qf8TXUKeMlQIRMk3F5GA30UH0KpMin0wT1S2OA2q3V5wDEZj6Ylh-fFLk98yS_ijHIDBtQ5Ti-g665QjQZmLhsh8BdmhmlTmgeDcmo0RnXZBUaM5Hb5WLY-w4M4OgTsbDe4sOLjzQ-DOR4M79wf3ATADprPjV3vF0F3feHhi-kKQiC4o794DiVSqJK1ULVypZAyStDxYr7af7_0AMVbBozuG0lbdTIbCyoZAcxw8Md0ytEEE4NegqJWPAtZx8gT3N0SbbWstBRUq-FMtPX6NvXIIAifSm6zBVAU322TAjnetPfH8vlR7vX0CtzwZePIaS08MF1QSwcqIrqNqKzVo0kqV0HVCa9UxXH0-ngivyQ4SQRXGewbSR52n6Z0qnSgT0eiOYex18i4jEYhIGHF7RzxtIYmoFLqwXND0sV3XyjaxtokyS2qb4wX-D-cwnaHTd9RX_MC-wzEPBMdk7AASlXR4j1p7-P5NhySjrMFTPUeftXYQnF0dIFB5lgIIyXsa11o-okR7n1BLBzY9yEQlHbN0IMgZxdpXdU89mFJHObTxcb18iyZXGPEtzKJLIHp2fFHrk6zSt1BaST_KjqMn0CvTcHTn5QruA9eKZG0VrwbJDKZqjsUdrK5TAIw2koX5p1S9IBJldAcZoq377UGgHCaFkSYF2lF1CBwoiQZSTfaJzjFkMB4b05_u-x1kYANfsW3RBLuNBfGPVQ5cmK5jqEZMbfSDe-jJWvwY5gPeASYAg_cPva--QsA6mx7rxS2VZtSu33v5A9SocGnreq-6_KyDUWjpKHzCxglSPAOqb8n3h2M8zD7XEOMe4FTfdH13nNVVGYdW03HyB3j29uxddANI9Jt7vbwZc71VQmWRNOFy1WRu3wwj5ZmhXQL7u-qeruH_mu8VXIXka8JNytfNMJrvJ8BC8jXhJuXrZhjN930RlK8JNylfN8MPrG8Zdn3Lyde39OF7I8PeV3Ly-0p63Vc3Eofliyfni73Or9wEPb863LTn18kwmu8SFiH5mnCT8nUzjOZ7q8b6gHxNuEn5uhlG8_1MdyH5mnCT8nUzjOZ7CdOQfE24Sfm6GY7z_XYS56oRlwz2_eyQqeyEI0rsj3XNW2i4BhKLhAGy0Z5KtEZYQBYvHlTIClT1ci7Wr3iUPSJQjyEFYCDnlVn9iUDCYKFw6R-QftpnAr_gG4DJX_D_lLf3Mx-5Zj5hzXygmvn8NPNxaebT0cyHoZnPPjMfdWY-2cx8kPk_zi2F6uztjKFGhmfzHC9OT2KkOnd-B9mdEbx7W3l_KO3Qof6v23r1ZEIp0YZRWdR682AN9HQkuVjS1nfNuZp7UEvyosoKcCox0JNMDgVDqZ1vUpqrcQdxSqp3zYvnFz0bkepzaPOxUbw4f_kXWygOvQ',
        },
      ];
    }

    return [
      ...baseItems,
      {
        type: 'single',
        icon: 'mdi-package-variant',
        title: 'Forecasting for bundles',
        link: '/reports/38/bundles-demand-forecasting/609?report_query=eJztWW1v2zYQ_iuCgAEbbBW2EtuJv6XJBgxr16xOAwxBIDAS7XClRFWkPAtB_vuOlG2eaNmzHSxDgXwJIvK5e-6F4p3OT75iilN_7P-azWmmRFF5n2nOacbkYwoLftePH0mhbqpco-DxkchLveKPVVHSri8fxd_LhSnhUq9QTmNFk0tSJJeCl2km_fHdk5-RVOu4LkRSxkazSAy1oumd_uNdURkXLFdMZPewnxBFlsSKLrQEL5n8SPKcZTNYfKiifKnsubvWf0sKRjKkf75e-DeFKyTSNvnti9W0ZIvk1_Ig84wAUvqZiiKhhfdHCWxMVZbhjq3yEBU4D044EhqzlPANyi3SbdxXRFHEW9TLEZBQl6xGNpkwHqv_kjElvYngCVIu4TH6tnQ2yklB0j0dapHcZNMgLwefEoJDSea0IDMKJjJeRaWGRkbfIQbsVoJtuUj-KiUce688yihJOJWRKmiWvNQ0pAob-IGSxLthKfV-BJvkT8gqODWJKCIOiEgBYk8LXLHGi0OmVFXeRIn4Kz4KZjmSehkE55TvexI2BNtO9bVg-NVfH-tcr-_J1JDBJPaObHlxL2JVEu5tYvZk3SrftCAWKeDbb456L7KXwLfDTNihARtxBYfHE1MPl4yUsEwrQYk2idIHDanLOck0bt-c79KBTfoI7GmZtkXPWgSuHR-bduGGDWSxhw1k8QIbWoXb4mDeOu9SzM1FX0knCnVcY71tontADFzRtgjsYgcXjmVvEW3z_dO20qrNr9_sI3LfFGzzejsvGH4c74Yg5v2FLaDYbGWd6u3jeNtE2y7byyrmbT1ErNcPvGyNjFva4QxJfJuvKp6udXAKpHujx2UBRS-utpbKtaD_fN_1U0pkWdAdfRNoh7KWSWhI64bO9pJSQc9bV72xH_bC06B3HoQj2IGi2Fjvh0E41KrolJRcRQXJZnrzJIXFKeOKFrg_th2U91B578ssgWq-tZl6MPs6DnPCSwDc-T0ffBPQehDwCCRmqj0VOgQ5mwsVCdNy1_296WsaDfsEOnzvRuTWBiXyDDNecK45zfOSRELgzeFo6ZKZVLcaWrOwxB8Phl3_A3mAmj72BwC5rTXD__pEGMTIIvo9BIGHNebMYkKMCRHmHDFhzMBihj2L0a5ZkH7SYeOCJOZkmU8edGp_XsS81FueKFUgpoG5sbykcQvCViSmEapudCWGo5qJlwV12Ldu_C6QF6B47WpoMX-aY7YCVfC009V1v3tjGs21d7j7RN70XWe0xU1XsjJ9gHeh1RmU2k6_1_sBZ_edTR3Kbue8geq_O1-j-ijBnTMHdmZhKICdkQMbWRiKYWfowIYWdoJgAwdmD3r_FMFOHdiphQ0Q7MSBnVgYerE6oQMLLWzUCG8T1rcwnIUmymJQCoKmqh5KQYhSEIQOzKYgRCkIThyYTUGIUhCcOjCbghClIBg4MJuCEKUgGDowm4IQpSAYOTCbghClIDhzYDYFIUpBcO7A-m2v4r0dteiyJQpd2r7zccv_ORlpFt6JuWtx4cVf2GZzT-oNue2k-1f7g2cntSimXpKZScX2YQ30Zq2srRndJvs2IfouJkRvA47lJbQcZ2wOyl51qvG6I7TXHQ--ysDubSz0NhZ6Gwv9t2MhPUTQNaaeIUDr-WSe4UOg6zPoMuU1La7NwgBafgld6vtKfw9u7-fua5juTgGof2WElVkhytxIrh6W-3qOA1V1ItAvkGnJFUMrz1370x2daZZIt9xgT0x4XHKiW-iUqoLFslYJdQLKN5Miq3_hGj89P_8DSs_0ZA',
      },
      {
        type: 'single',
        icon: 'mdi-chart-timeline-variant',
        title: 'Inventory burndown',
        link: '/reports/measures/inventory_burndown?report_query=eJzVWltv2zYU_iuCgAEtGhe2HOdi7KVJ2y3b0mZx2mEwAoGWaIcrLaoUmdQI8t_HiyxSF8dyRD_0Ja0Ov3P4HR5eDg_96DPEMPTH_kVyDxNG6Mo74zSJyUPiH_jRHaDsZpVKwNnFb-GnL5dnH65Fwx3IzmWbP2aUwwM_uyMPZQHEMGIwPgc0PieYL5PMH08f_QQspbErSmIeMe9iCRZQdkRiKUb5ZwwYyLtdizBH2SVIU5QsLCngjExUV_54DnAGpSlM6EUSwx-FKCOUgZl0U5J7OqjSMAQuGFxO5R_vPcwiilKGSHJbZsTgD1YjNFuFaWGsI6uvgCKQWKzuC8E2GgbZkcPkzy-m_9yzMPvGdxqKXMHNcHgXcW1EQhSXCSV8OYN007BouCM6n9Xc8AZ1UkS1DNqHy9JwSy7YRC7YmVzgnNxwE7nhzuSG3cmdAarI1Cb9rGjYxqmu0ZHTlwQx75xk1lbAhSiMtMjiE3FKYRKtapxsfNctAWIsjHpXFEWwwijNZa0prRU6cvpM0QIlAFdJkVy-E7GaUkdy_0C0uLNixwgTxh_W0u3bVkXBCR1PTirDSRsPuRZum-FldEc-v0_E3LZX3F0WtlxpBtmRwznhCRM5D5l7eioZNpFuCsk8JOumbbyadDoyNHnZDQXRN9mPSZd0G1uFzLRt49io1HkYE4YSDr0s3yMe7mDiEc7kwGaMRN_scdXYMMeGAhauMdsH-BllN8lgKc9Yb-kt84wS3BEd1WONENPSHXKxXKPrGQ7F3YAaPvrb-yRbW9G5XxvoehrxNMUIWlQyI9nGw4I6itKEAcazhpR5Ld8la17ruJpBYNHAjGnpLjMIONkqsNQVSVsDp6jU2DbfKmt1HTQ-wyi7g7H3HrCGhZeu28NYt1ssc0kzy5qis4Phby4yYcRWhuz0XcS4yIrqmMpdNoaRuErjGumN-t15fyQURiBjDca9K0gRsbbfKUNLGKZKGqbonoitda0VSh66zBDKLtrc0ncw5yZ7z7wJwbE3W3kTwQBDa85PZRaVhZloDzPV2DI2NT3XVM94Epepqs6-51EKZ6q9JdsmVQe3NU3Rk9Y38hSBbubafCZs0O1O9hPUWbce4c10AQXLF42q0nRwmeKsR-Y9lU6J3W9lzwCZZ4msVrWJDWyVtSRa03Ox8TVTRMnu9Eo6rtaRDI4nJpAnjFr8wD2kYAFFVwivQmsV7xL454109-Bd_B_PmDj9-ItcyYBYlWL_FEleV4csUy7mTESW8mLScFaivM06C77vdlo-Y8HlOf8VYG5lJPVDXpaKKpQ3FjsalbuzvYZMBLJG1Ra3ZVgx5b6WVkzjokjWllpNcW_VtWlJ3pZf1dieqmzTcsWsLTvXdbb1PUf8OxdBvgS0VMiZFhm4ag-Xqr1CVuxxEUw23zFKut0py6NL1kbM8ruGS4CSUnlnao4ma2dJMUgkrm2m8JyN7o4E_eDQew8j71Vh_XXL_F1_y0TLGLkkCbt73c6zlxu3fdbPlbbL-QNm4bEagrLLI-8PkHR1OTeyH5erxl_i8u2Bv4Qg49SqNVKZwxfvw7Ggk2Ti4p3XdorXx4wBKu5RqJgjvf5JbyAfuMRxbslHvX7Q6x9JU3AOOGYhBclCNg5O-vLcnyPMIG16Ot5acblXB8d4Ko86dA994Q4RowOEEwIOvzfcCbrUXYvu_v0wadWXwOiQ6TcsdbMTo4ASKB1X-Vz5zVyFvVoP1HMhL-4VHJYy7pKFkuTdFrfFhqsQypg6aHWPKPbHR0cH_l9gBrEvnw6gLLDqo1g-A4hPOVYKd2xwarpZQE1DeooJiNUcrq6mIuG8yTO9dTWvlP4Vjg2qTknmZZdMbbbu1Inh-mbQ7_9icQ3e9gufTi3YaQk1eHtaoAZ9C3ZSgZ0Y2MCCHVdgxwYWWLCjCuzIwIYWbFSBjQzs0IIdVmCHBjayYMMKbGhg1lx4E1RggYEdl4a3DBsYmB2FMspgrBD0yqb6VggCKwS9oAIzIQisEPSGFZgJQWCFoHdYgZkQBFYIeqMKzIQgsELQO6rATAgCKwS94wrMhCCwQtA7qcBMCAIrBL3TCmzw_FIsKnM3Yn_2XsmcwTrY5nmr3r3tJXnSb7PTmGVZ7v_W_FgopDAVZ5As6O7nB0P7_umP2x_x2FVzlUtbNdPnroHOar0_d573c6dsVfYf4aw7e2VkX-zLxh3k2OIi191lZWRfLpeNO3D5XerAZWVkXy6XjTuJ8spFlFf7jPLK8eWRu9iJ-D53It718lhzGbtwGe_TZex4LfOFg7UsjextLZeMv7BEkMpCqL7CioztUX2L_P3ARyKXysSl9UoJRn2tfbaSOeOGZOtWY6RMoFQXQrSghKdKb_2RA2SBQlweJ4Sa4tWSY4YsyZNwA-CIYyATzCVkFEWZ1o3IUtyyUUYS_SQ_fnzKfb7mOL806lT0XAcOYFzkpkUCPChd9X_1cxPi_3QxexWMRgde0D9Uf16vG0Wo8jDqjNffUmnRtYLkPCfDRXI4Hj79D_efdsE',
      },
      {
        type: 'single',
        icon: 'mdi-transfer',
        title: 'Inventory movement-based',
        link: '/reports/38/inventory-movement-based-forecasting/661?report_query=eJytV21v6jYU%2FiuRpUmbRq6SAIXyre3dpGqrbjdopQlVkRsb6l0nzmyHDVX89x0nATsmVLDdL4gcP%2BfF57HPOX5HmmlO0QzdFxtaaCG3wYPY0Bz%2Bh7dYURL8LCTNsNKsWAcrIYNHKUiV6eAZS4YLjQYoe8NSL7alMTN%2Feni4%2Bf0PkL5hdWcW0EzLig6QehN%2Ft4IV5spIKKeZpuQOS3IneJUXCs2W76jAuTHlOBDECDYHAcEatw41%2FcdIeMXUAy5LiBLNiorz3eBgaL%2BDYI45VcFvFRhhemsNL1ctIlUGkf7VIl66rgjNWI657w2d0EZOCAuhMQ%2BeCqZVMBecOL4rI0wVCFO25yAtOS4KsH5mBB%2FaQLuXAcopVpU0NixgZZlNlRbZ1zRvqTdeGfxRTBSg8rpNbe6VBg5Tzep9JVEyCqNJGE9hhRakI4%2BjMJ4YU3SFK65TiYu1WRzmIFwxrqkEviG4km2ETkWpG3ewWmKJ885pOJC4AA%2FB9wRv1Q82iwcKav8DOCq8AvkSDSP00n62OVSwXU67eS2q%2FBWCgc0Jqb9IYgJDcRSZRAtM6iTXh9ah9Ib8WSk4vcFCwsZtKM0h0K3wEEjsx8GZ0ieiMEvPBtpkgBE0mw7Qr%2FiVcoD9CIF9B6jnxjRKPkX1UTOwawd23UHFn64PqDhyYFMPNrWw2IFNPNjEwhIHduXBrixs6MDGHmxsYSMHNvJgIwsbO7ChBxta2JUDSzxYYmGTTnq7sNjCXBa6KItxKAi7piKHgsShIEw8mKUgcSgIhx7MUpA4FIQjD2YpSBwKwrEHsxQkDgXhlQezFCQOBeHEg1kKEoeCcOrBLAWJQ0F47cHiuoa5l3PUczdfbEtJJS0BnWbHbWXfv%2B5zvKb22rL607nfLc4i7jXNl%2BYn%2BExVJlldrrwC3deNTPksW2OO%2FW%2FW3ua%2FPFkjraNUfa0uiqxW6OuZi6agHnVKU2i9zdv61d8e69rc58POHj29%2BZx%2BdWabPKv1OQHe0jWrW2hfXK%2F7xUvHhWPFU5PCZ2qooe60QFqR0%2BcvdP%2BBhVNx3BDSCQKb7%2F8ewSl11%2F1PBTmRd1qvXOjTuzLd9AYllQEMFO4ON1RCPUgJZnybNuPVPnHn7vIDE6hvjvhfQaXO2PENAnTNucHu%2BQi%2BFOEbdsee5U2mKzgxx3f5zHBO6rv%2B74tM5OZgHGCdStEsXnoej%2FQ6ZRoyIORxgd3s5RfU2FbHO4jBnVBOG6gfBNC4lF%2FVskoCHdm2d%2FqvFXraV6CN8lH0rfSC2GuNHvvwHNCV6mlAe%2FklPajRMY28NCezeRFA936vv2G4GiAGDVg9UvlYC8ZRMxbcbs2MfWavaEcJ08VBy7xOQbKWoiprM%2FuPdt08nuCCzoXzcs3hOcMcyW5g903XxktqZhoILsM8qzg2VyqnWrJMNSbhxMEbhylRwP3TsJP33e5fTcYtcQ%3D%3D',
      }
    ];
  }

  private expandedSections: { [key: string]: boolean } = {};

  private toggleSection(sectionId: string) {
    // copy value of the sectionId
    const sectionStatus = this.expandedSections[sectionId];
    // Collapse all sections first
    Object.keys(this.expandedSections).forEach(key => {
      this.$set(this.expandedSections, key, false);
    });
    // Then expand/collapse the clicked section
    this.$set(this.expandedSections, sectionId, !sectionStatus);
  }

  private toggleSubSection(sectionId: string) {
    // Collapse all sections first
    Object.keys(this.expandedSections).forEach(key => {
      if (key !== sectionId) {
        this.$set(this.expandedSections, key, false);
      }
    });
  }

  async created() {
    await this.loadForecastMethodology();
    // Initialize only first section as expanded
    const firstSection = this.getMenuItems[0];
    if (firstSection) {
      this.$set(this.expandedSections, firstSection.section, true);
    }
    
    const savedMode = localStorage.getItem('menuMode');
    // Only restore operational mode if user has access
    if (savedMode && (savedMode === 'ANALYTICS' || this.canAccessOperationalMode)) {
      this.menuMode = savedMode;
    } else {
      this.menuMode = 'ANALYTICS';
    }
    
  }

  private async loadForecastMethodology() {
    try {
      await this.forecastSetting.load();
      this.currentMethodology = this.forecastSetting.options?.methodology || 'simple_average';
    } catch (error) {
      this.currentMethodology = 'simple_average';
    }
  }

  @Watch('mini', { immediate: true, deep: true })
  public onExpandMenu(newVal: any) {
    if (!this.mini) {
      this.pinMenu();
    }
  }

  private openChat(): void {
    const openChatMessage = 'I would like to unlock the Replenishment Center feature';
    // @ts-ignore: Unreachable code error
    this.$crisp.do("chat:open");
    // @ts-ignore: Unreachable code error
    this.$crisp.do("message:send", ["text", openChatMessage]);
  }

  private bookMeeting(): void {
    this.showOperationalDialog = false;
    // Navigate to Calendly link for booking a meeting
    window.open('https://calendly.com/assisty/replenishment-center-beta-access', '_blank');
  }

  // Add data property
  private showOperationalDialog: boolean = false;
}
